/* =====================================================================
   AIM STRAIGHT DARTS — MYSTERY BOX
   Progressive enhancement for snippets/as-mystery-options.liquid. The
   selections already work without this file; it only:
   1. repairs the `form` attribute if Liquid could not supply the id;
   2. drops the notes property when the box is left empty, so orders do
      not carry a blank "Current Darts & Preferences:" line;
   3. drives the character counter.
   ===================================================================== */

(() => {
  const NOTES_NAME = 'properties[Current Darts & Preferences]';

  function init(root) {
    if (root.dataset.asMysteryReady) return;
    root.dataset.asMysteryReady = 'true';

    // 1. Point every input at the product form in the same section.
    // ⛔ Read the id with getAttribute, never `form.id`: the product form
    // contains <input name="id"> (the variant), and named form controls
    // shadow form properties, so `form.id` returns that INPUT element.
    // Using it wrote form="[object HTMLInputElement]" and silently dropped
    // every line-item property from the cart (found in the live launch test).
    const scope = root.closest('product-info, section, .shopify-section') || document;
    const form = scope.querySelector('form[data-type="add-to-cart-form"]');
    const formId = form && form.getAttribute('id');
    if (formId) {
      root.querySelectorAll('input, textarea').forEach((el) => {
        if (el.getAttribute('form') !== formId) el.setAttribute('form', formId);
      });
    }

    // 2 + 3. Notes field: counter, and only submit when non-empty.
    const notes = root.querySelector('[data-as-mystery-count]');
    const count = root.querySelector('[data-as-mystery-count-value]');
    if (!notes) return;

    const sync = () => {
      if (count) count.textContent = notes.value.length;
      if (notes.value.trim()) notes.setAttribute('name', NOTES_NAME);
      else notes.removeAttribute('name');
    };
    notes.addEventListener('input', sync);
    sync();
  }

  const run = () => document.querySelectorAll('[data-as-mystery-options]').forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', run);
})();
